import z from 'zod';

import {
  AddressFormField,
  addressFormFieldDefaultValues,
  addressFormFieldSchema,
} from '@/components/forms/address-form-field';
import { TextFormField } from '@/components/forms/text-form-field';

export const asnAddressFieldsDefaultValues = {
  companyName: '',
  contactName: '',
  contactNumber: '',
  contactEmail: '',
  ...addressFormFieldDefaultValues,
};

export const asnAddressFieldsSchema = addressFormFieldSchema.extend({
  companyName: z.string().trim(),
  contactName: z.string().trim().min(1, 'Enter a contact name'),
  contactNumber: z.string().trim(),
  contactEmail: z.string().trim(),
  country: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{2}$/, 'Enter a two-letter country code'),
});

export function AsnAddressFields() {
  return (
    <>
      <TextFormField name="companyName" label="Company name" />
      <TextFormField name="contactName" label="Contact name" />
      <div className="grid gap-x-4 gap-y-2 sm:grid-cols-2">
        <TextFormField name="contactNumber" label="Phone" />
        <TextFormField name="contactEmail" label="Email" />
      </div>
      <AddressFormField />
    </>
  );
}
